<header class="header">
	<nav class="menu" aria-label="Navegação Principal">
		<div class="menu-container">
			<mat-icon
				class="menu-button"
				svgIcon="pm-icons:menu-hamburger"
				id="hamburger-menu"
				(click)="openMenu()"
			></mat-icon>
		</div>
		<!--		<div class="nav-buttons">-->
		<!--			<a routerLink="/" [ngClass]="{ active: router.url === '/' }">Restaurantes</a>-->
		<!--		</div>-->
	</nav>
	<div class="logo">
		<mat-icon routerLink="/" svgIcon="pm-icons:logo"></mat-icon>
	</div>
	<div class="user">
		@if (concierge$ | async; as concierge) {
			<span style="color: var(--content-primary-sidebar)">Olá, {{ concierge.name }}.</span>
		} @else {
			@if (client$ | async; as client) {
				<span style="color: var(--content-primary-sidebar)">Olá, {{ client.firstName }}.</span>
			} @else {
				@if (isMobile) {
					<a routerLink="entrar" class="login-button">Entrar</a>
				} @else {
					<button mat-raised-button routerLink="entrar">
						<span> Entrar <mat-icon svgIcon="pm-icons:profile"></mat-icon></span>
					</button>
				}
			}
		}
	</div>
</header>

<pm-menu-mobile #menu></pm-menu-mobile>
